var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.22754C6.49 2.22754 2 6.71754 2 12.2275C2 17.7375 6.49 22.2275 12 22.2275C17.51 22.2275 22 17.7375 22 12.2275C22 6.71754 17.51 2.22754 12 2.22754ZM16.78 9.92754L11.11 15.5975C10.97 15.7375 10.78 15.8175 10.58 15.8175C10.38 15.8175 10.19 15.7375 10.05 15.5975L7.22 12.7675C6.93 12.4775 6.93 11.9975 7.22 11.7075C7.51 11.4175 7.99 11.4175 8.28 11.7075L10.58 14.0075L15.72 8.86754C16.01 8.57754 16.49 8.57754 16.78 8.86754C17.07 9.15754 17.07 9.62754 16.78 9.92754Z",
    fill: "#9CD323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/tick-circle.de111b73821f558e02a1e7bf81ccb1ff.svg";
export { ForwardRef as ReactComponent };